import {createSlice, current} from '@reduxjs/toolkit';

import {getSearchResultPath, removeExtraCachedItems} from './utils';

import type {CachedTableData, ResponseData} from './typedef';
import type {Draft, PayloadAction} from '@reduxjs/toolkit';
import type {Error} from 'src/openapi/admin/models/Error';


export const getCachedTableDataSlice = <Data, SearchFields, SortFields, Filters>(name: string) => createSlice({
    name,
    initialState: {
        isLoading: false,
        loadingError: null,
        isRefreshRequired: false,
        cache: [],
    } as CachedTableData<Data>,
    reducers: {
        clearData: state => {
            state.isLoading = false;
            state.loadingError = null;
            state.isRefreshRequired = false;
            state.cache = [];
        },
        requireRefresh: state => {
            state.isLoading = false;
            state.loadingError = null;
            state.cache = [];
            state.isRefreshRequired = true;
        },

        /* API reducers */
        startLoading: state => {
            state.isLoading = true;
        },
        onSuccess: (
            state,
            action: PayloadAction<ResponseData<Data, SearchFields, SortFields, Filters>>,
        ) => {
            const {cache} = current(state);
            const {cacheKeys, totalCount, data} = action.payload;

            const cacheKey = getSearchResultPath(cacheKeys);

            state.cache = [...removeExtraCachedItems(cache.filter(({key}) => key !== cacheKey)), {
                key: cacheKey,
                item: {
                    totalCount,
                    data: data as Draft<Data>,
                },
            }];
            state.loadingError = null;
            state.isLoading = false;
            state.isRefreshRequired = false;
        },
        onFailure: (state, action: PayloadAction<Error>) => {
            state.loadingError = action.payload;
            state.isLoading = false;
            state.isRefreshRequired = false;
        },
    },
});
